export default {"src":"/_next/static/media/Group.ef12ff79.svg","height":49,"width":48,"blurWidth":0,"blurHeight":0};